/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity, enumeration } from '@gh/core-data';
import { SubOfficeDetailsDto } from '../models/sub-office-details.dto';
import { SubOfficeStatus } from '../models/sub-office-status.enum';

export const SubOfficeDetailsMapper = entity<SubOfficeDetailsDto>({
  status: enumeration(SubOfficeStatus),
  formedDate: date(DateFormat.Date),
});
